var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-box-title center-items"},[_c('h2',{staticClass:"title",attrs:{"data-aos":"fade-right","data-aos-duration":"1000","data-aos-delay":"300"}},[_vm._v(" "+_vm._s(_vm.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }